<template>
  <div class="container login-container">
      <div class="login-div rounded shadow ">
          <div class="logo-holder">
              <img :src="ProGoLoGo" alt="ProGoLoGo" class="img-fluid" style="width: 300px; margin: 0 auto; display: block;">
          </div>
          
              
          <div class="fw700 em2">Register</div>
              <div class="mt-2 mb-3">
                  <label for="institution">Select Your Institution: </label>
                  <select class="form-select" id="institution" name="institution" autocomplete="institution" v-model="selectedInstitution" required>
                        <option selected value="maricopa">Maricopa Community Colleges</option>
                        <option value="unaffiliated">Unaffiliated</option>
                  </select>
              </div>
              <div class="input-row">
                  <div class="input-group">
                      <label for="firstName">First Name:</label>
                      <input type="text" id="firstName" name="given-name" autocomplete="given-name" v-model.trim="firstName" required>
                  </div>
                  <div class="input-group">
                      <label for="lastName">Last Name:</label>
                      <input type="text" id="lastName" name="family-name" autocomplete="family-name" v-model.trim="lastName" required>
                  </div>
              </div>
              <div class="input-group">
                  <label for="email">Enter Your Email Address:</label>
                  <input type="email" id="email" name="email" autocomplete="email" v-model.trim="email" required>
                  <small id="emailError">Please use your @maricopa.edu email address</small>
              </div>
              <div class="input-group">
                  <label for="password">Choose a Password:</label>
                  <input type="password" id="password1" name="password" v-model="password1" required>
                  <small class="error" id="p1error"></small>
              </div>
              <div class="input-group">
                  <label for="password">Re-enter Password:</label>
                  <input type="password" id="password2" name="password" v-model="password2" required>
                  <small class="error" id="p2error"></small>
              </div>
              <button class="login-button" @click="registerAccount">Register Account</button>
  
      </div>
  </div>
  </template>
  
  <script>
  // Import proport functions from firebase to create a new user account
  import { auth, database } from '../main';
  import { createUserWithEmailAndPassword } from 'firebase/auth';
  import { collection, doc, getDocs, setDoc } from 'firebase/firestore';

  import ProGoLoGo from '../assets/ProGoLoGo.png';
  
  
  export default {
    name: "loginPage",
    data() {
      return {
          ProGoLoGo,
          selectedInstitution: 'maricopa',
          firstName: '',
          lastName: '',
          email: '',
          password1: '',
          password2: '',
      }
    },
    watch: {
        selectedInstitution(newVal) {
            if (newVal === 'unaffiliated') {
                document.getElementById('emailError').innerText = '';
            } else {
                document.getElementById('emailError').innerText = 'Please use your @maricopa.edu email address';
            }
      }
    },
    methods: {
      async shouldShowLessonVideos(email) {
          const normalizedEmail = email.trim().toLowerCase();

          try {
              const snapshot = await getDocs(collection(database, 'users'));

              return snapshot.docs.some((userDoc) => {
                  const userData = userDoc.data();
                  const cohorts = userData.cohorts || [];

                  return cohorts.some((cohort) => {
                      if (!cohort.online || !cohort.emails) {
                          return false;
                      }

                      const cohortEmails = cohort.emails
                          .split(',')
                          .map((cohortEmail) => cohortEmail.trim().toLowerCase())
                          .filter(Boolean);

                      return cohortEmails.includes(normalizedEmail);
                  });
              });
          } catch (error) {
              if (error.code === 'permission-denied') {
                  return false;
              }

              throw error;
          }
      },
      async registerAccount() {
          document.getElementById('emailError').innerText = "Please use your @maricopa.edu email address";
          const loginEmail = this.email.trim();
          const loginPassword1 = this.password1;
          const loginPassword2 = this.password2;
          const firstName = this.firstName.trim();
          const lastName = this.lastName.trim();
          if (!firstName || !lastName) {
              document.getElementById('p1error').innerText = "First and last name are required";
              return;
          } else {
              document.getElementById('p1error').innerText = "";
          }
          if (loginPassword1 !== loginPassword2) {
              document.getElementById('p2error').innerText = "Passwords do not match";
              return;
          } else {
              document.getElementById('p2error').innerText = "";
          }
          if (!loginEmail.includes('@maricopa.edu') && this.selectedInstitution === 'maricopa') {
              document.getElementById('emailError').classList.add('error');
              return;
          } else {
              document.getElementById('emailError').classList.remove('error');
          }
          try {
              const showLessonVideos = await this.shouldShowLessonVideos(loginEmail);
              const userCredential = await createUserWithEmailAndPassword(auth, loginEmail, loginPassword1);
              const user = userCredential.user;
              await setDoc(doc(database, 'users', user.uid), {
                userInfo: {
                  email: user.email,
                  firstName,
                  lastName,
                  showLessonVideos,
                }
              });
              const redirect = this.$route.query.redirect || '/settings'; 
              this.$router.push(redirect);
          } catch (error) {
              const errorCode = error.code;
              const errorMessage = error.message;
              if (errorCode === 'auth/email-already-in-use') {
                document.getElementById('emailError').innerText = "Email address already in use";
                document.getElementById('emailError').classList.add('error');
              } else if (errorCode === 'permission-denied') {
                document.getElementById('p1error').innerText = "Account created, but profile setup was blocked by database permissions.";
              } else {
                console.log('Error:', errorMessage);
              }
          }
      },
    }
  }
  </script>
  
  <style scoped>
  .logo-holder {
      text-align: center;
      padding: 10px;
      border-radius: 5px;
      background: linear-gradient(90deg in oklab, blue, red);
  }
  .login-container { 
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 24px 0;
  }
  .input-group {
      margin-bottom: 20px;
  }
  .input-row {
      display: flex;
      gap: 16px;
  }
  .input-row .input-group {
      flex: 1;
  }
  .input-group label {
      display: block;
      margin-bottom: 5px;
  }
  .input-group input {
      width: 100%;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
  }
  .login-button {
      width: 100%;
      padding: 10px;
      background: linear-gradient(90deg in oklab, blue, red);
      color: white;
      font-weight: 600;
      border: none;
      border-radius: 5px;
      cursor: pointer;
  }
  .login-button:hover {
      background: linear-gradient(270deg in oklab, blue, red);
  }
  .login-div {
      left: auto;
      margin-top: 50px;
      padding: 24px 24px 32px;
      width: 500px;
      min-height: 760px;
      background-color: var(--off_white);
  }
  .error {
      color: red;
  }
  @media (max-width: 576px) {
      .input-row {
          flex-direction: column;
          gap: 0;
      }
      .login-div {
          width: 100%;
          height: auto;
      }
  }
  </style>
